"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPillsWrapper = exports.StyledTitleWrapper = exports.StyledTemplatesWrapper = exports.StyledSearchBoxWrapper = exports.StyledHeadingWrapper = exports.StyledWrapper = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 100%;
`;
exports.StyledHeadingWrapper = styled_components_1.default.div `
  display: flex;
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.Components.Panel.Background};
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Elevated};
`;
exports.StyledSearchBoxWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)} 0 ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledTemplatesWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-flow: column;
  margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)} 0 ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledTitleWrapper = styled_components_1.default.div `
  margin: ${({ theme }) => `0 0 ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledPillsWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)} 0 ${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
`;
//# sourceMappingURL=TemplateOverview.style.js.map